import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "../types/api";

/**
 * Shared React Query client with production-sensible defaults:
 *  - a short stale window so data feels live without hammering the API,
 *  - no retries on 4xx (client) errors — only transient network/5xx failures,
 *  - no refetch-on-focus storms for a dense internal dashboard.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError) {
          if (error.isNetworkError) return failureCount < 2;
          if (error.status >= 400 && error.status < 500) return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
